"use client"
import {
  LineChart
} from "./chunk-ZWA4FO4Q.mjs";

// src/components/radar-chart.ts
import { mergeMultiStyle } from "@yamada-ui/core";
var RadarChart = mergeMultiStyle(
  LineChart,
  {
    baseStyle: {
      polarAngleAxis: {},
      polarAngleAxisTick: {
        "& > text": {
          fill: "muted",
          fontSize: "xs"
        }
      },
      polarGrid: {
        stroke: ["blackAlpha.400", "whiteAlpha.400"],
        strokeWidth: 1
      },
      polarRadiusAxis: {
        "& > line": {
          stroke: ["blackAlpha.400", "whiteAlpha.400"]
        }
      },
      polarRadiusAxisTick: {
        "& > text": {
          fill: "muted",
          fontSize: "xs"
        }
      },
      radar: {}
    },
    sizes: {
      sm: {
        container: {
          w: "full"
        }
      },
      md: {
        container: {
          w: "full"
        }
      },
      lg: {
        container: {
          w: "full"
        }
      },
      full: {
        container: {
          w: "full"
        }
      }
    }
  }
)({ omit: ["line", "grid"] });

export {
  RadarChart
};
//# sourceMappingURL=chunk-W2AZP736.mjs.map